<template>
  <div class="theme-hero-area">
    <div class="theme-hero-area-bg-wrap">
      <div
        class="theme-hero-area-bg"
        :style="{'background-image': 'url(' + require('@/assets/img/bg-home.jpg') + ')'}"></div>
      <div class="theme-hero-area-bg theme-hero-grad-mask"></div>
    </div>
    <div class="theme-hero-area-body">
      <div class="theme-page-section theme-page-section-xl">
        <div class="container">
          <div class="row">
            <div class="col-md-4 col-md-offset-4">
              <router-link to="/login">
                <span class="center-block mt-20 _mb-30">
                  <img
                    class="img-responsive"
                    src="@/assets/img/logo-experience.png"
                    alt="Logo Tour House"
                    title="Tour House">
                </span>
              </router-link>
            </div>
            <div class="col-md-12 theme-login-white">
              <h1 class="theme-login-title text-center mb-20 h2">
                Esqueceu sua senha?
              </h1>
            </div>
            <form @submit.prevent="handleSubmit">
              <div class="col-md-4 col-md-offset-4">
                <div class="theme-login theme-login-white">
                  <div class="theme-login-box">
                    <div class="theme-login-box-inner">
                      <p class="theme-login-pwd-reset-text">
                        Digite o e-mail associado a sua conta no campo abaixo, enviaremos em seu e-mail um link para recuperar sua senha.
                      </p>
                      <div class="form-group theme-login-form-group">
                        <input
                          class="form-control"
                          type="text"
                          name="email"
                          v-model="email"
                          v-validate="'required|email'"
                          placeholder="Endereço de e-mail"
                          :class="{ 'alert-danger': errors.has('email') }">
                        <span class="error-message-forms">{{ errors.first('email') }}</span>
                      </div>
                      <button
                        :disabled="submitted"
                        type="submit"
                        class="btn btn-uc btn-dark btn-block btn-lg">
                        <i class="fa fa-envelope" aria-hidden="true"></i> Enviar e-mail
                      </button>
                      <router-link to="/login">
                        <a class="theme-login-pwd-reset-back">Lembra sua senha?</a>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      email: null,
      submitted: false
    };
  },
  methods: {
    ...mapActions('user', [
      'postPasswordRecover'
    ]),

    handleSuccess (response) {
      if (typeof response.data.error == 'undefined') {
        this.$swal({
          title: response.data.message,
          type: 'success',
          showConfirmButton: false,
          timer: 2000
        });

        setTimeout(() => {
          this.$router.push('/');
        }, 2000);
      } else {
        this.handleError()
      }
      this.submitted = false;
    },

    handleError () {
      this.$swal({
        title: 'Favor verificar os campos',
        type: 'error',
        confirmButtonText: 'SAIR'
      });
      this.submitted = false;
    },

    handleSubmit(e) {
      e.preventDefault();
      this.$validator.validateAll()
        .then(result => {
          if (!result) return false;

          this.submitted = true;
          this.postPasswordRecover({ email: this.email })
            .then(this.handleSuccess)
            .catch(this.handleError)
      });
    }
  }
};
</script>

<style scoped>
.theme-hero-area {
  min-height: 100vh;
  height: auto;
}
</style>
